import React, { PureComponent } from 'react'
import Pagination from '../../Hocs/Pagination'

import Page from './page'

export default class Summary extends PureComponent {
  render () {
    const { items } = this.props
    if (items.length > 6) {
      return <Multipage {...this.props} />
    } else {
      return <Page {...this.props} maxPerPage={6} />
    }
  }
}

const Multipage = Pagination({
  numberOfSlides: 2,
  renderItem: (props, index) => {
    const { length } = props.items
    let maxPerPage = 6
    if (length > 6 && length <= 8) {
      maxPerPage = 4
    }

    const items1 = props.items.slice(0, maxPerPage)
    const items2 = props.items.slice(maxPerPage)
    if (index === 0) {
      return <Page {...props} items={items1} maxPerPage={maxPerPage} active={props.currentPage === 0} />
    } else if (index === 1) {
      return <Page {...props} items={items2} maxPerPage={maxPerPage} active={props.currentPage === 1} />
    }
  }
})
